import { PercentToggle } from '../types';
import { BaseToggleStrategy } from './BaseToggleStrategy';

export class RoutingToggleStrategy<T> extends BaseToggleStrategy<T> {
  private readonly selectedRoutingPercent = Math.random();

  public determineToggleValue(toggleValue: ToggleValue<PercentToggle<T>>): T {
    const { value, percent } = this.getTargetedValue(toggleValue);
    let rv: T;

    if (percent >= this.selectedRoutingPercent) {
      rv = value;
    }

    return rv;
  }

  public isValidToggle(toggleValue?: ToggleValue<PercentToggle<T>>): boolean {
    const { value } = toggleValue ?? {};

    return value && value.hasOwnProperty('value') && !isNaN(value?.percent);
  }
}
